export default __webpack_public_path__ + "static/warehouse-presentation-72691809979318cc466af30119501315.webp";